import lazyTriggers from './lazy-triggers.js';

export default {
    observer: null,

    init() {
        this.applyToExisting();
        this.observeMutations();
        lazyTriggers.init();
    },

    applyToExisting() {
        document.querySelectorAll('[data-fancybox]').forEach((el) => {
            this.decorateTrigger(el);
        });
    },

    decorateTrigger(element) {
        if (!element) return;
        if (!element.dataset.chunk) {
            element.dataset.chunk = 'fancybox';
        }
        if (!element.dataset.chunkLazy) {
            element.dataset.chunkLazy = 'click';
        }
        const preload = element.dataset.chunkPreload?.trim();
        if (!preload) {
            element.dataset.chunkPreload = 'pointerdown';
        } else if (!preload.split(/\s+/).includes('pointerdown')) {
            element.dataset.chunkPreload = `${preload} pointerdown`.trim();
        }
    },

    observeMutations() {
        if (this.observer) return;

        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof HTMLElement)) return;
                    if (node.matches('[data-fancybox]')) {
                        this.decorateTrigger(node);
                    }
                    node.querySelectorAll?.('[data-fancybox]').forEach((el) => {
                        this.decorateTrigger(el);
                    });
                });
            });
        });

        this.observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    },
};
